import React from "react";
import Page from "../../models/page/Page";
import PageRepository from "../../repository/PageRepository";
import StandardFormComponent from "../basics/form/StandardFormComponent";
import { withRouter } from 'react-router-dom';
import FormToastComponent from "../basics/FormToastComponent";
import FormHelper from "../../helpers/FormHelper";
import CheckPermissions from "../../helpers/CheckPermissions";
import UserRolesEnum from "../../enums/UserRolesEnum";
import ModuleRepository from "../../repository/ModuleRepository";
import { LoaderComponent } from "../basics/layout";
import Module from "../../models/module/Module";
import ModuleTypeEnum from "../../enums/ModuleTypeEnum";
import { CategoryRepository } from "../../repository";
import PageTextFormComponent from "./forms/PageTextFormComponent";

class PageConfigFormComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            model: this.props.model !== undefined ? this.props.model : new Page(),
            loading: true,
            pages: [],
            types: [],
            selectedType: null,
            modulesList: [],
            modules: [],
            categories: [],
            selectedModulesData: [],
            selectedModulesSettingsData: [],
            isEdit: false,
            roles: this.props.user.roles,
        };

        this.customProps = { ...this.props };
        this.isManager = CheckPermissions.role(this.state.roles, UserRolesEnum.MANAGER) && !CheckPermissions.role(this.state.roles, UserRolesEnum.RESELLER);
    }

    componentDidMount() {
        let promises = [
            PageRepository.getTypes(),
            PageRepository.all(),
            ModuleRepository.all(),
            CategoryRepository.all()
        ];

        if (this.props.get_promise !== undefined) {
            promises.push(this.props.get_promise)
        }

        Promise.all(promises)
            .then(result => {
                let types = result[0];
                let pages = result[1];
                let modules = result[2];

                if (types !== undefined && types.data !== undefined) {
                    types = types.data.map(type => ({ value: type, label: type }));

                    if (this.isManager) {
                        types = types.filter(type => type.value === 'url' || type.value === 'text')
                    }

                    types = types.filter(type => type.value !== 'sitemap');
                }

                let pagesList = [];
                if (pages !== undefined) {
                    pagesList = pages.map(page => {
                        return {
                            value: page.page.id,
                            label: '-'.repeat(page.index) + " " + page.title,
                            isDisabled: page.index >= 2
                        }
                    });
                }

                let modulesList = [];
                let modulesLinked = [];
                if (modules !== undefined) {
                    // Ignore module referenced to other module and without content
                    modulesLinked = modules.map(module => {
                        if (Module.hasContent(module.module)) return null;
                        return parseInt(Module.getSetting(module.module, 'module'))
                    }).filter(x => x);
                    modules = modules.filter(module => modulesLinked.indexOf(module.id) < 0);

                    // Ignore Client and attendee modules
                    modules = modules.filter(module => [ModuleTypeEnum.ATTENDEE, ModuleTypeEnum.CLIENT, ModuleTypeEnum.MAP].indexOf(module.module.type) < 0).filter(x => x);

                    modules.forEach(module => modulesList.push({ value: module.id, label: module.title, type: module.module.type }));
                }

                let model = this.state.model;
                let selectedType = this.state.selectedType;

                if (result[4] !== undefined) {
                    let page = Page.fromJson(result[4]);
                    let pageContent = page.content.filter(content => content.language === this.props.match.params.language)[0];
                    model = {
                        id: page.id,
                        name: pageContent.title,
                        type: page.type,
                        modules: page.modules,
                        module_categories: page.module_categories,
                        module_settings: page.module_settings,
                        parent: page.parent,
                        settings: page.settings,
                        _page: page
                    }

                    selectedType = page.type;
                }


                // Load selected category modules
                let loadSelectedCategorymoduleIds = modules
                    .filter(module => (model.modules || []).indexOf(module.id) > -1)
                    .filter(module => module.module.type === ModuleTypeEnum.CATEGORY)
                    .map(module => module.id)
                    ;

                Object.keys(model.module_categories).forEach(moduleId => {
                    model['category_' + moduleId] = model.module_categories[moduleId];
                });

                this.setState({
                    types: types,
                    selectedType: selectedType,
                    pages: pagesList,
                    modulesList: modulesList,
                    modules: modules,
                    categories: result[3],
                    model: model,
                    loading: false,
                    isEdit: model.id !== undefined
                }, () => {
                    this.loadSelectedCategorymodule(loadSelectedCategorymoduleIds);
                    this.loadSelectedModulesSettings(model.modules || []);
                })
            })
    }

    render() {
        if (this.state.loading) return <LoaderComponent />;

        return (
            <StandardFormComponent
                {...this.customProps}
                parent={this}
                className="page"
                validationSchema={Page.schema_add}
                model={this.state.model}
                formSubmit={(values, formikActions) => {
                    values = { ...values, id: values.id, language: this.props.match.params.language, settings: { ...values.settings }, module_settings: { ...values.module_settings }, title: values.name, modules: values.modules };

                    if (this.state.isEdit) {
                        return PageRepository.update(values)
                            .then(() => {
                                FormToastComponent.successTrans("Pages", "Default.saved");
                                this.props.history.push("/" + this.props.slug);
                            })
                            .catch(error => FormHelper.handleSubmitError(this, error))
                    } else {
                        return PageRepository.create(values)
                            .then(() => {
                                FormToastComponent.successTrans("Pages", "Default.saved");
                                this.props.history.push("/" + this.props.slug);
                            })
                            .catch(error => FormHelper.handleSubmitError(this, error))
                    }

                }}
                formErrors={this.state.form_errors}
                fields={PageTextFormComponent.addFields(this, { ...this.state, ...{ isManager: this.isManager } })}
            />
        );
    }

    handleTypeChange = (event, value) => this.setState({ selectedType: value });

    formatModulesValue = (event) => event.map(module => module.value);

    loadSelectedCategorymodule = (selectedIds) => {
        let selectedModulesData = [];

        if (selectedIds.length > 0) {
            let modules = this.state.modules.filter(module => selectedIds.indexOf(module.id) > -1);

            modules.forEach(module => {
                selectedModulesData.push({
                    module: module,
                    categories: this.state.categories.filter(category => category.module === module.id && category.index <= 0)
                });
            });

            this.setState({ selectedModulesData: selectedModulesData });
        }
    }

    loadSelectedModulesSettings = (selectedIds) => {
        let selectedModulesSettingsData = this.state.modules.filter(module => selectedIds.indexOf(module.id) > -1);
        this.setState({ selectedModulesSettingsData: selectedModulesSettingsData });
    }

    handleModuleSelection = (e) => {
        let selected = e || [];
        this.loadSelectedCategorymodule(selected.filter(record => record.type === ModuleTypeEnum.CATEGORY).map(item => item.value));
        this.loadSelectedModulesSettings(selected.map(item => item.value));
    }
}

export default withRouter(PageConfigFormComponent);